import { ElTableColumn } from 'element-plus'

ElTableColumn['props'].showOverflowTooltip = { type: Boolean, default: true }
ElTableColumn['props'].formatter = {
  type: Function,
  default: (_: any, __: any, cellValue: string | number) => {
    if (cellValue === 0)
    { return 0 }
    return cellValue || '-'
  },
}

export {
  ElTableColumn,
}
